// extracted by mini-css-extract-plugin
export default {"banner":"suEtf","wrapper":"GeFWp e2H7L","content":"ksqbt","title":"w4gdc","description":"ILesx","imageWrapper":"K8woE","image":"MdlUd"};